"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionLinkBodySchema = exports.SubscriptionSessionBodySchema = exports.SUBSCRIPTION_ACCESS_HEADER = exports.SubscriptionAccessActionSchema = exports.SubscriptionAccessReferenceSchema = exports.SubscriptionAccessIdSchema = void 0;
exports.subscriptionAccessCookieName = subscriptionAccessCookieName;
exports.subscriptionAccessCookie = subscriptionAccessCookie;
exports.readSubscriptionAccessCookie = readSubscriptionAccessCookie;
const zod_1 = require("zod");
exports.SubscriptionAccessIdSchema = zod_1.z.string().uuid();
exports.SubscriptionAccessReferenceSchema = zod_1.z.union([
    exports.SubscriptionAccessIdSchema, zod_1.z.string().regex(/^legacy_[a-f0-9]{64}$/),
]);
exports.SubscriptionAccessActionSchema = zod_1.z.enum(['PAY_INVOICE', 'UPDATE_PAYMENT_METHOD', 'CANCEL']);
exports.SUBSCRIPTION_ACCESS_HEADER = 'x-subscription-access';
exports.SubscriptionSessionBodySchema = zod_1.z.object({
    accessId: exports.SubscriptionAccessIdSchema, code: zod_1.z.string().regex(/^[A-Za-z0-9_-]{43}$/),
}).strict();
exports.SubscriptionLinkBodySchema = zod_1.z.object({
    accessId: exports.SubscriptionAccessReferenceSchema, action: exports.SubscriptionAccessActionSchema, requestId: zod_1.z.string().uuid(),
}).strict();
function subscriptionAccessCookieName(accessId) {
    return `__Host-vp_subscription_${exports.SubscriptionAccessIdSchema.parse(accessId)}`;
}
function subscriptionAccessCookie(accessId, rawSession, expiresAt, now) {
    return `${subscriptionAccessCookieName(accessId)}=${rawSession}; Path=/; Secure; HttpOnly; SameSite=Lax; Max-Age=${Math.max(0, Math.floor((expiresAt.getTime() - now.getTime()) / 1000))}; Expires=${expiresAt.toUTCString()}`;
}
function readSubscriptionAccessCookie(accessId, cookie) {
    if (!exports.SubscriptionAccessIdSchema.safeParse(accessId).success)
        return undefined;
    const name = subscriptionAccessCookieName(accessId);
    const matches = (cookie ?? '').split(';').map(part => part.trim()).filter(part => part.startsWith(`${name}=`));
    if (matches.length !== 1)
        return undefined;
    const value = matches[0].slice(name.length + 1);
    return /^[A-Za-z0-9_-]{43}$/.test(value) ? value : undefined;
}
//# sourceMappingURL=subscription-access.js.map